const getCookie = (name: string) => {
  const cookieMatch = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return cookieMatch ? decodeURIComponent(cookieMatch.pop() || '') : null;
};

export default getCookie;
